<div *ngIf="!hideNavigation" class="card flex">
  <p-breadcrumb
    class="max-w-full flex-1"
    [model]="breadcrumbsItems"
    [home]="breadcrumbsHome"
  />
  <wiki-help [sectionId]="'FORMGENERATOR'"></wiki-help>
  <tenant-notifications [category]="'ALL'"></tenant-notifications>
</div>

<div *ngIf="!hideNavigation" class="mt-3 flex flex-row">
  <div class="flex-1 text-color text-3xl font-semibold leading-normal">
    {{ "formGenerator.header.title" | translate }}
  </div>
  <div class="gap-4 mt-1 flex">
    <p-fileupload
      mode="basic"
      name="demo[]"
      chooseIcon="pi pi-upload"
      accept="application/json"
      maxFileSize="1000000"
      (onSelect)="onSelectImportFormFile($event)"
      [auto]="true"
      [chooseLabel]="'formsCommon.editor.action.import' | translate"
    />
    <p-button
      (click)="onExportFormFile()"
      [label]="'formsCommon.editor.action.export' | translate"
      icon="pi pi-download"
      iconPos="left"
    />
  </div>
</div>

<div
  class="mt-4 flex flex-1 flex-wrap gap-6 items-center justify-between p-1 gap-20"
  style="min-width: 1300px"
>
  <div class="flex flex-col self-start flex-1" style="height: 100%">
    <div class="card-dashboard p-6">
      <div class="font-semibold text-muted-color text-md flex">
        <div class="flex-1">
          {{ "formGenerator.itemCategory.elements" | translate }}
        </div>

        <div>{{ "formGenerator.itemCategory.containers" | translate }}</div>
      </div>
      <div class="flex-1 mt-3 flex gap-5 flex-row">
        <div
          class="ui-elements--draggable flex-1 gap-4 flex-wrap flex-row flex content-start"
          style="display: grid; grid-template-columns: auto auto auto auto"
        >
          <div
            *ngFor="let inputElement of uiAll.inputs"
            [attr.item-id]="inputElement.id"
            class="{{ uiElementClasses }} bg-surface-50"
          >
            <i class="{{ inputElement.icon }}"> </i>
            <span>{{ inputElement.label | translate }}</span>
          </div>
        </div>

        <div
          class="ui-elements--draggable flex gap-4 flex-wrap flex-col"
          style="border-left: 3px solid #e5e7eb; padding-left: 1.25rem"
        >
          <div
            *ngFor="let containerElement of uiAll.containers"
            [attr.item-id]="containerElement.id"
            class="{{ uiContainerClasses }} bg-surface-50  "
          >
            <i class="{{ containerElement.icon }}"> </i>
            <span>{{ containerElement.label | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <p-selectbutton
      [(ngModel)]="selectedMode"
      [options]="modeOptions"
      aria-labelledby="basic"
      [allowEmpty]="false"
      [unselectable]="true"
      (onChange)="changeSelect()"
    ></p-selectbutton>

    <ng-container *ngIf="selectedMode === designMode && !refreshingUi">
      <ng-container
        *ngFor="let field of fieldsRaw"
        [ngTemplateOutlet]="fieldTemplate"
        [ngTemplateOutletContext]="{ field: field }"
      >
      </ng-container>
      <ng-template #fieldTemplate let-field="field">
        <div
          *ngIf="field?.wrappers?.length || field?.fieldArray"
          [id]="field.id"
          class="relative nested-sortable {{ getWrapperClasses(field) }} flex-1"
        >
          <div
            *ngIf="field.key != undefined && field.key != ''"
            class="absolute top-0 px-2 bg-white left-2 border border-dashed border-primary border-t-0 text-sm overflow-hidden text-ellipsis text-primary-500"
          >
            {{ field?.key }}.
          </div>

          <div
            *ngIf="showFieldErrors(field)"
            class="absolute top-0 font-bold text-sm text-red-700"
            style="right: 1.5rem; padding-top: 3px"
          >
            <i class="pi pi-exclamation-triangle"></i>
          </div>

          <div class="absolute top-0 right-5 font-bold text-sm">
            <div *ngIf="isEmptyForm()">
              {{ "formGenerator.hint.startDragging" | translate }}
            </div>
            <ng-container
              *ngIf="field?.wrappers?.length && uiAllBySubId[field.wrappers[0]]"
            >
              <i
                style="padding-top: 3px"
                class="absolute {{ uiAllBySubId[field.wrappers[0]].icon }} "
              >
              </i>
            </ng-container>
            <ng-container *ngIf="field?.fieldArray">
              <i
                style="padding-top: 3px"
                class="absolute  {{ uiAllBySubId[field.type].icon }} "
              >
              </i>
              <!-- {{ field.type }} -->
            </ng-container>
          </div>

          <ng-container *ngIf="!field.fieldArray">
            <ng-container
              *ngFor="let item of field.fieldGroup"
              [ngTemplateOutlet]="fieldTemplate"
              [ngTemplateOutletContext]="{ field: item }"
            >
            </ng-container>
          </ng-container>
          <ng-container *ngIf="field.fieldArray">
            <ng-container
              *ngFor="let item of field.fieldArray.fieldGroup"
              [ngTemplateOutlet]="fieldTemplate"
              [ngTemplateOutletContext]="{ field: item }"
            >
            </ng-container>
          </ng-container>
        </div>
        <ng-container *ngIf="!field?.wrappers?.length && !field?.fieldArray">
          <div
            class="relative
            overflow-ellipsis
            whitespace-nowrap
            overflow-hidden
            select-none
            {{ uiElementClasses }}
            max-w-40

            cursor-pointer hover:bg-primary-200 {{
              selectedUidElement === field.id ? 'bg-primary-300' : 'bg-white'
            }}"
            [id]="field.id"
          >
            <i
              class="{{ uiAllBySubId[field.type].icon }} {{
                field.key != undefined && field.key != '' ? 'mt-4' : ''
              }}"
            >
            </i>

            <div
              *ngIf="field.key != undefined && field.key != ''"
              class="absolute top-0 px-2 bg-white left-2 border border-dashed border-primary border-t-0 text-sm overflow-hidden text-ellipsis text-primary-500"
              style="max-width: calc(100% - 5px)"
            >
              {{ field?.key }}
            </div>

            <!--<div class="absolute bottom-0 right-5 font-bold text-sm">
              {{ field.type }}
            </div> -->
            <div
              class="overflow-hidden text-ellipsis ml-1 {{
                field.key != undefined && field.key != '' ? 'mt-4' : ''
              }}"
            >
              {{ field?.props?.label ?? "&nbsp;" }}
            </div>
          </div>
        </ng-container>
      </ng-template>
    </ng-container>

    <div *ngIf="selectedMode !== designMode" class="mt-3">
      <form-viewer
        [(payload)]="model"
        [formFields]="fieldsFormly"
        [formButtons]="buttonsFormly"
        (payloadSubmit)="onFormModelChange($event)"
      ></form-viewer>

      <!--<form
        [formGroup]="form"
        class="form-container--formly"
        (ngSubmit)="onSubmit(model)"
      >
        <formly-form
          [form]="form"
          [fields]="fieldsFormly"
          [model]="model"
          (modelChange)="onFormModelChange($event)"
        ></formly-form>
        <div class="form-container--formly__buttons">
          <p-button type="submit" label="Submit"></p-button>
        </div>
      </form> -->
    </div>
  </div>

  <div
    class="flex flex-1 flex-row self-start"
    style="max-width: 580px; min-width: 550px"
  >
    <!--<p-selectbutton
      [(ngModel)]="selectedItemMode"
      [options]="modeItemOptions"
      aria-labelledby="basic"
      [allowEmpty]="false"
      [unselectable]="true"
      (onChange)="changeItemSelect()"
    ></p-selectbutton>-->

    <div *ngIf="selectedUidElement" class="card-dashboard h-full p-6 flex-1">
      <div class="flex-1 flex gap-5 flex-col">
        <div class="font-semibold text-muted-color text-md flex">
          <div class="flex-1">
            {{ "formGenerator.itemCategory.selectItem" | translate }}
          </div>
        </div>
        <form-viewer
          *ngIf="selectedUidElement"
          [(payload)]="modelUiSelected"
          [formFields]="fieldsUiSelected"
          [formButtons]="buttonsUiSelected"
          [showRemoveButton]="true"
          (payloadSubmit)="onSubmitUiSelected($event)"
          (actionSelect)="removeUiSelected()"
        ></form-viewer>
      </div>
    </div>
  </div>
</div>
<!--<div class="col-span-12 xl:col-span-6">
  <div class="card-dashboard h-full p-6">
    <div *ngIf="selectedUidElement" class="flex-1 mt-3 flex gap-5 flex-col">
      <form-viewer
        *ngIf="selectedUidElement"
        [(payload)]="modelUiSelected"
        [formFields]="fieldsUiSelected"
        [formButtons]="buttonsUiSelected"
        [showRemoveButton]="true"
        (payloadSubmit)="onSubmitUiSelected($event)"
        (actionSelect)="removeUiSelected()"
      ></form-viewer>
    </div>
  </div>
</div> -->
